import React from 'react';
import { useT } from '../../../i18n';
import cranniCoin from '../../../assets/images/cranni-coin.webp';

const SIZES = {
  sm: 'h-6 w-6',
  md: 'h-12 w-12',
  lg: 'h-24 w-24',
  xl: 'h-32 w-32',
};

/**
 * Brand loading spinner: the Cranni skull coin inside a turning gilt ring. Replaces
 * the inline SVG that used to be copy-pasted across every page that fetches on-chain data.
 */
const Spinner = ({ size = 'md', label, className = '' }) => {
  const t = useT();
  const text = label || t('bvb.loading');

  return (
  <div className={`flex flex-col items-center justify-center gap-3 ${className}`} role="status">
    <div className={`relative ${SIZES[size] || SIZES.md}`} aria-hidden="true">
      <svg className="spin absolute inset-0 h-full w-full" viewBox="0 0 100 100" fill="none">
        <circle cx="50" cy="50" r="46" strokeWidth="4" style={{ stroke: 'rgba(var(--lb-gilt-rgb), 0.18)' }} />
        <path d="M50 4a46 46 0 0 1 46 46" strokeWidth="4" strokeLinecap="round" style={{ stroke: 'var(--lb-gilt)' }} />
      </svg>
      <img src={cranniCoin} alt="" className="absolute inset-[18%] h-[64%] w-[64%] animate-lb-pulse rounded-full" />
    </div>
    <span className="sr-only">{text}</span>
  </div>
);
};

export default Spinner;
